import { useTranslation } from 'react-i18next'
import styles from './Spinner.module.scss'

interface SpinnerProps {
  size?: 'small' | 'normal' | 'fullscreen'
  text?: string
  variant?: 'page' | 'fullscreen' | 'inline'
}

export default function Spinner({ 
  size = 'normal', 
  text,
  variant = 'page'
}: SpinnerProps) {
  const { t } = useTranslation('common')
  
  const getSpinnerClass = () => {
    const baseClass = styles.spinner
    const sizeClass = size === 'small' ? styles.spinnerSmall : ''
    const variantClass = variant === 'fullscreen' ? styles.spinnerFullscreen : 
                        variant === 'page' ? styles.spinnerPage : ''
    
    return `${baseClass} ${sizeClass} ${variantClass}`.trim()
  }

  const displayText = text || t('status.loading')

  return (
    <div className={getSpinnerClass()}>
      <div className={styles.spinnerContainer}>
        <div className={styles.spinnerWheel} />
        <div className={styles.spinnerText}>
          {displayText}
        </div>
      </div>
    </div>
  )
}
